import { render, staticRenderFns } from "./DokumentyKasowe.vue?vue&type=template&id=bbde9e90&scoped=true&"
import script from "./DokumentyKasowe.vue?vue&type=script&lang=js&"
export * from "./DokumentyKasowe.vue?vue&type=script&lang=js&"
import style0 from "./DokumentyKasowe.vue?vue&type=style&index=0&id=bbde9e90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbde9e90",
  null
  
)

export default component.exports